import { Routes, Route } from 'react-router-dom'; 
import ProtectedRoute from './components/ProtectedRoute'; 
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login'; 
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Docs from './pages/Docs';
import ForgotPassword from './pages/ForgotPassword';
import Signup from './pages/Signup'; 
import Contact from './pages/Contact';
import AdminDashboard from './components/admin/AdminDashboard';

export default function AppRoutes() {
  return (
    <>
    
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin/*"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />

          {/* Catch all - 404 */}
          <Route path="*" element={<div>404 - Not Found</div>} />
        </Routes>
      
    </>
  );
} 